var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeUpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.503,
    height: 49.795,
    viewBox: "0 0 62.503 49.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_Volume_Up",
    "data-name": "Iconly/Light/Volume Up",
    transform: "translate(0.858 1.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Volume_Up",
    "data-name": "Volume Up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M32.112,38.081a36.2,36.2,0,0,1-.746,5.195,5.1,5.1,0,0,1-4.841,3.984,5.8,5.8,0,0,1-3.377-1.39L12.023,36.833h-6.2c-2.989,0-5-2.037-5.409-5.393a75.479,75.479,0,0,1,0-15.8c.407-2.91,2.42-5.2,5.409-5.2h6.2l10.9-8.882A6.686,6.686,0,0,1,26.526,0a5.108,5.108,0,0,1,4.841,3.984,41.052,41.052,0,0,1,.746,5.2C32.619,13.23,32.619,34.034,32.112,38.081Z",
    transform: "translate(0 0.738)",
    fill: "none",
    stroke: "#200e32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_3",
    "data-name": "Stroke 3",
    d: "M0,0A25.977,25.977,0,0,1,4.292,14.793,25.967,25.967,0,0,1,0,29.583",
    transform: "translate(43.845 9.04)",
    fill: "none",
    stroke: "#200e32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_5",
    "data-name": "Stroke 5",
    d: "M0,0C4.321,6.215,6.915,14.551,6.915,23.832S4.321,41.451,0,47.666",
    transform: "translate(53.98)",
    fill: "none",
    stroke: "#200e32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUpIcon);
export default __webpack_public_path__ + "static/media/volume_up_icon.88bb37505b5896d4d1e1b6c673ef2c64.svg";
export { ForwardRef as ReactComponent };